import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=b3bba8f0&"
import script from "./PageNotFound.js?vue&type=script&lang=js&"
export * from "./PageNotFound.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageNotFound.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcommon%2FPageNotFound%2FPageNotFound.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports